// Libraries.
import { cloneDeep } from 'lodash/fp'

/**
 * Retrieves the log level for a specified logger type, or the default level.
 * @method getLevel
 * @param  {Object} state            SDK redux state.
 * @param  {String} [type='DEFAULT'] A type of Logger.
 * @return {string} A log level.
 */
export function getLevel (state, type = 'DEFAULT') {
  const clonedState = cloneDeep(state)
  return clonedState.logs[type]
}

/**
 * Retrieves a list of all of the SDK's Logger types.
 * @method getTypes
 * @param  {Object} state  SDK redux state.
 * @return {Array<string>}
 */
export function getTypes (state) {
  const clonedState = cloneDeep(state)
  return Object.keys(clonedState.logs)
}
